import {UserTenancyDto} from '@tpa/api';

export function checkUserIdentifer(userIdentifer: {
  userId: number;
  tenantId: number;
}, accounts: UserTenancyDto[]) {
  return userIdentifer.userId &&
    accounts.filter(f => f.tenantId === userIdentifer.tenantId && f.id === userIdentifer.userId && f.canAccess2FAIsEnabled).length === 1
}
